<template>
<Teleport to="body">
    <div class="fixed flex z-100 justify-center items-center top-0 left-0 right-0 bg-slate-900/50 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative w-full max-w-md max-h-full">
            <div class="relative bg-white rounded-lg shadow">
                <div class="p-6 text-center">
                    <h1 class="mb-5 text-5xl font-semibold">
                        <slot name="counter"></slot>
                    </h1>
                    <h3 class="mb-5 text-lg font-semibold">
                        <slot name="text"></slot>
                    </h3>
                </div>
            </div>
        </div>
    </div>
</Teleport>
</template>   